import { Paper, PaperProps, styled } from '@mui/material';

const ReportCard = styled(Paper, { shouldForwardProp: prop => prop !== 'printPageBreak' })<
  PaperProps & { printPageBreak?: boolean }
>({
  padding: '24px',
  breakAfter: 'auto',
  '@media print': {
    padding: '10px',
    breakInside: 'avoid',
  },
  variants: [
    {
      props: ({ printPageBreak }) => printPageBreak,
      style: {
        breakAfter: 'page',
      },
    },
  ],
});

export default ReportCard;
